exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".knob {\n  /*width: 250px;*/ }\n\n.knob-container {\n  text-align: center; }\n\n@media (min-width: 360px) {\n  .knob-container {\n    padding: 10px 50px;\n    width: 100%; } }\n\n@media (min-width: 600px) {\n  .knob-container {\n    padding: 10px;\n    width: 100%; } }\n\n.knob-helper {\n  position: absolute;\n  background-color: black;\n  z-index: 9999;\n  margin: auto;\n  width: 30%;\n  height: 150px; }\n\n.knob .value {\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./src/js/components/Knob/knob.scss
// module id = 177
// module chunks = 0